<template>
    <div
        id="home-service"
        class="row service-package"
    >
        <div class="bld-features col-xs-12 p-a-0 m-y">
            <div class="service-details col-xs-12 col-md-4 text-center m-y">
                <div class="img-container">
                    <img src="images/icons/build-ico.png" alt="" class="m-auto">
                </div>
                <div class="content">
                    <div class="text-white text-upper">
                        <h3 class="text-bold">OPTIMIZED FOR GAME <br> PERFORMANCE</h3>
                    </div>
                </div>
                <router-link to="/what-is-bld" class="link-btn link-white">
                    LEARN MORE
                    <i class="fa fa-chevron-right" aria-hidden="true" />
                </router-link>
            </div>

            <div class="service-details col-xs-12 col-md-4 text-center m-y">
                <div class="img-container">
                    <img src="images/icons/glass.png" alt="" class="m-auto">
                </div>
                <div class="content">
                    <div class="text-white text-upper">
                        <h3 class="text-bold">CLEAR, COMPETITIVE<br>PRICING</h3>
                    </div>
                </div>
                <router-link to="/what-is-bld" class="link-btn link-white">
                    LEARN MORE
                    <i class="fa fa-chevron-right" aria-hidden="true" />
                </router-link>
            </div>

            <div class="service-details col-xs-12 col-md-4 text-center m-y">
                <div class="img-container">
                    <img src="images/icons/2year-ico.png" alt="" class="m-auto">
                </div>
                <div class="content">
                    <div class="text-white text-upper">
                        <h3 class="text-bold">2-YEAR WARRANTY ON ALL<br>PARTS AND LABOR</h3>
                    </div>
                </div>
                <router-link to="/what-is-bld" class="link-btn link-white">
                    LEARN MORE
                    <i class="fa fa-chevron-right" aria-hidden="true" />
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";

export default {
    name: "ServicePackage",
    props: {
        slickConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isProduction: CONFIG.PRODUCTION
        };
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            $(".bld-features").slick(
                Object.assign(_cloneDeep(this.slickConfig), {
                    dots: true
                })
            );
        }
    }
}
</script>

<style lang="scss">
.service-package {
    .slick-dots li button::before {
        color: #FFF !important;
    }
}

.service-package {
    .slick-track {
        margin: 0 auto !important;
    }
}
</style>

<style lang="scss" scoped>
.service-package {
    background-image: none !important;
    padding: 15px 0;

    .service-details {
        margin-bottom: 40px !important;
    }

    h3.text-bold {
        font-size: 26px !important;
    }
}
</style>
